import { LazyAction, LazyImport, LazyModule } from 'owa-bundling';
var lazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "InlineImageLoader" */ './lazyIndex');
});
export var lazyClearInlineImageStore = new LazyAction(lazyModule, function (m) { return m.clearInlineImageStore; });
export var lazyTryCreateDataURIFromImage = new LazyImport(lazyModule, function (m) { return m.tryCreateDataURIFromImage; });
export var lazyCacheInlineImage = new LazyImport(lazyModule, function (m) { return m.cacheInlineImage; });
export var lazyLogImageUpload = new LazyImport(lazyModule, function (m) { return m.logImageUpload; });
export var lazyLogImageLoadError = new LazyImport(lazyModule, function (m) { return m.logImageLoadError; });
export var lazyLoadFromAttachmentServiceUrl = new LazyImport(lazyModule, function (m) { return m.loadFromAttachmentServiceUrl; });
export var lazyLoadFromAttachment = new LazyImport(lazyModule, function (m) { return m.loadFromAttachment; });
export { default as inlineImageStore } from './store/store';
//# sourceMappingURL=index.js.map